export const SourceAarStorage = "aarstorages";

export const Titles = { list: "AAR Storage List", edit: "Edit AAR Storage", create: "Create AAR Storage" };
